/* ClassySticks – fraktmåler og forhåndsvisning av handlekurven når man holder over kurvikonet. */
(function () {
  // Må stemme med fraktprisen "Standard 0 kr fra 850 kr" i Shopify (i øre).
  const FREE_SHIPPING_THRESHOLD = 85000;

  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const canHover = window.matchMedia('(hover: hover) and (pointer: fine)');
  const money = new Intl.NumberFormat('nb-NO', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  const shortMoney = new Intl.NumberFormat('nb-NO', { maximumFractionDigits: 2 });

  const formatMoney = (cents) => `${money.format(cents / 100)} kr`;

  function el(tag, className, text) {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  }

  /* ---------- Fraktmåler ---------- */
  function createProgress() {
    const wrap = el('div', 'cs-shipping');
    const label = el('p', 'cs-shipping__label');
    label.setAttribute('aria-live', 'polite');
    const track = el('div', 'cs-shipping__track');
    track.setAttribute('role', 'progressbar');
    track.setAttribute('aria-label', 'Gratis frakt');
    track.setAttribute('aria-valuemin', '0');
    track.setAttribute('aria-valuemax', '100');
    track.appendChild(el('div', 'cs-shipping__fill'));
    wrap.append(label, track);
    return wrap;
  }

  function updateProgress(wrap, cart) {
    const percent = Math.min(100, Math.round((cart.total_price / FREE_SHIPPING_THRESHOLD) * 100));
    const remaining = FREE_SHIPPING_THRESHOLD - cart.total_price;
    const reached = remaining <= 0;
    let text = `Du mangler ${shortMoney.format(remaining / 100)} kr for gratis frakt`;
    if (reached) text = 'Du har gratis frakt!';
    else if (cart.item_count === 0) text = `Gratis frakt på bestillinger over ${shortMoney.format(FREE_SHIPPING_THRESHOLD / 100)} kr`;

    wrap.hidden = cart.item_count > 0 && !cart.requires_shipping;
    wrap.classList.toggle('cs-shipping--reached', reached);
    wrap.querySelector('.cs-shipping__label').textContent = text;
    wrap.querySelector('.cs-shipping__track').setAttribute('aria-valuenow', String(percent));
    wrap.querySelector('.cs-shipping__fill').style.width = `${percent}%`;
  }

  /* ---------- Forhåndsvisning ---------- */
  function imageUrl(src) {
    const url = new URL(src, window.location.origin);
    url.searchParams.set('width', '128');
    return url.href;
  }

  function createItem(item) {
    const row = el('li', 'cs-preview__item');
    const media = el('a', 'cs-preview__media');
    media.href = item.url;
    media.tabIndex = -1;
    media.setAttribute('aria-hidden', 'true');
    if (item.image) {
      const img = el('img');
      img.src = imageUrl(item.image);
      img.alt = '';
      img.width = 64;
      img.height = 64;
      img.loading = 'lazy';
      media.appendChild(img);
    }

    const info = el('div', 'cs-preview__info');
    const title = el('a', 'cs-preview__title', item.product_title);
    title.href = item.url;
    info.appendChild(title);
    const options = (item.options_with_values || [])
      .filter((option) => option.value !== 'Default Title')
      .map((option) => option.value)
      .join(' / ');
    if (options) info.appendChild(el('p', 'cs-preview__options', options));

    const stepper = el('div', 'cs-qty');
    const minus = el('button', 'cs-qty__button', '−');
    minus.type = 'button';
    minus.dataset.step = '-1';
    const plus = el('button', 'cs-qty__button', '+');
    plus.type = 'button';
    plus.dataset.step = '1';
    plus.setAttribute('aria-label', `Øk antall for ${item.product_title}`);
    stepper.append(minus, el('span', 'cs-qty__value'), plus);
    info.appendChild(stepper);

    row.dataset.key = item.key;
    row.append(media, info, el('p', 'cs-preview__price'));
    return row;
  }

  function updateItem(row, item) {
    const value = row.querySelector('.cs-qty__value');
    value.textContent = item.quantity;
    value.setAttribute('aria-label', `Antall: ${item.quantity}`);
    row.dataset.quantity = item.quantity;
    row
      .querySelector('[data-step="-1"]')
      .setAttribute('aria-label', item.quantity === 1 ? `Fjern ${item.product_title}` : `Reduser antall for ${item.product_title}`);
    row.querySelector('.cs-preview__price').textContent = formatMoney(item.final_line_price);
  }

  function createPanel() {
    const panel = el('div', 'cs-preview');
    panel.id = 'cs-cart-preview';
    panel.setAttribute('role', 'region');
    panel.setAttribute('aria-label', 'Innhold i handlekurven');

    const empty = el('p', 'cs-preview__empty', 'Handlekurven er tom');
    const list = el('ul', 'cs-preview__items list-unstyled');
    list.setAttribute('role', 'list');

    const error = el('p', 'cs-preview__error');
    error.setAttribute('role', 'alert');
    error.hidden = true;

    const total = el('div', 'cs-preview__total');
    total.append(el('span', '', 'Totalt'), el('span', 'cs-preview__total-value'));

    const actions = el('div', 'cs-preview__actions');
    const view = el('a', 'button button--secondary', 'Vis handlekurv');
    view.href = `${root}cart`;
    const checkout = el('a', 'button', 'Til kassen');
    checkout.href = `${root}checkout`;
    actions.append(view, checkout);

    panel.append(createProgress(), empty, list, error, total, actions);
    return panel;
  }

  function renderPanel(panel, cart) {
    const hasItems = cart.item_count > 0;
    updateProgress(panel.querySelector('.cs-shipping'), cart);
    panel.querySelector('.cs-preview__empty').hidden = hasItems;
    panel.querySelector('.cs-preview__items').hidden = !hasItems;
    panel.querySelector('.cs-preview__total').hidden = !hasItems;
    panel.querySelector('.cs-preview__actions').hidden = !hasItems;
    panel.querySelector('.cs-preview__total-value').textContent = formatMoney(cart.total_price);

    // Behold radene som finnes, så bilder ikke blinker og fokus ikke forsvinner når antallet endres.
    const list = panel.querySelector('.cs-preview__items');
    const current = [...list.children];
    const focused = list.contains(document.activeElement) ? document.activeElement : null;
    const focusedKey = focused && focused.closest('.cs-preview__item').dataset.key;
    const focusedStep = focused && focused.dataset.step;
    const rows = cart.items.map((item) => {
      const row = current.find((existing) => existing.dataset.key === item.key) || createItem(item);
      updateItem(row, item);
      return row;
    });
    if (rows.length !== current.length || rows.some((row, index) => row !== current[index])) {
      const scrollTop = list.scrollTop;
      list.replaceChildren(...rows);
      list.scrollTop = scrollTop;
      if (focused) {
        const row = rows.find((candidate) => candidate.dataset.key === focusedKey);
        const next = (row && row.querySelector(`[data-step="${focusedStep}"]`)) || panel.querySelector('.cs-preview__actions a');
        if (hasItems) next.focus({ preventScroll: true });
        else document.getElementById('cart-icon-bubble').focus({ preventScroll: true });
      }
    }
  }

  function showError(panel, message) {
    const error = panel.querySelector('.cs-preview__error');
    error.textContent = message || '';
    error.hidden = !message;
  }

  function updateCartIcon(cart) {
    const html = cart.sections && cart.sections['cart-icon-bubble'];
    const icon = document.getElementById('cart-icon-bubble');
    if (!html || !icon) return;
    const section = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
    if (section) icon.innerHTML = section.innerHTML;
  }

  function setupPreview(onOpen) {
    const icon = document.getElementById('cart-icon-bubble');
    const icons = icon && icon.parentElement;
    if (!icons || window.location.pathname.endsWith('/cart')) return null;

    const panel = createPanel();
    icons.classList.add('cs-preview-host');
    icon.after(panel);

    let closeTimer;
    const isOpen = () => panel.classList.contains('is-open');
    const open = () => {
      clearTimeout(closeTimer);
      if (isOpen()) return;
      panel.classList.add('is-open');
      onOpen();
    };
    const close = () => panel.classList.remove('is-open');
    const closeSoon = () => {
      clearTimeout(closeTimer);
      closeTimer = setTimeout(close, 220);
    };

    [icon, panel].forEach((target) => {
      target.addEventListener('pointerenter', (event) => {
        if (event.pointerType === 'mouse' && canHover.matches) open();
      });
      target.addEventListener('pointerleave', (event) => {
        if (event.pointerType === 'mouse') closeSoon();
      });
    });

    icon.addEventListener('focus', () => {
      if (icon.matches(':focus-visible')) open();
    });
    panel.addEventListener('focusin', () => clearTimeout(closeTimer));
    [icon, panel].forEach((target) => {
      target.addEventListener('focusout', (event) => {
        const next = event.relatedTarget;
        if (!next || !(icon.contains(next) || panel.contains(next))) closeSoon();
      });
    });
    icons.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && isOpen()) {
        close();
        icon.focus({ preventScroll: true });
      }
    });

    // Ikke vis panelet oppå "Lagt i handlekurven"-boksen.
    const notification = document.getElementById('cart-notification');
    if (notification) {
      new MutationObserver(() => {
        if (notification.classList.contains('active')) close();
      }).observe(notification, { attributes: true, attributeFilter: ['class'] });
    }

    return panel;
  }

  /* ---------- Oppstart ---------- */
  function init() {
    const bars = [];
    const cartBlocks = document.querySelector('#main-cart-footer .cart__blocks');
    if (cartBlocks) {
      const bar = createProgress();
      cartBlocks.prepend(bar);
      bars.push(bar);
    }
    const notificationLinks = document.querySelector('.cart-notification__links');
    if (notificationLinks) {
      const bar = createProgress();
      notificationLinks.before(bar);
      bars.push(bar);
    }

    let requestId = 0;
    let panel = null;
    let changing = false;
    const applyCart = (cart) => {
      bars.forEach((bar) => updateProgress(bar, cart));
      if (panel) renderPanel(panel, cart);
    };
    const refresh = async () => {
      if (changing) return;
      const id = ++requestId;
      try {
        const response = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
        if (!response.ok) return;
        const cart = await response.json();
        if (id !== requestId || changing) return;
        applyCart(cart);
      } catch (error) {
        console.error(error);
      }
    };

    const changeQuantity = async (key, quantity) => {
      changing = true;
      requestId++;
      panel.classList.add('is-busy');
      panel.setAttribute('aria-busy', 'true');
      showError(panel, '');
      try {
        const response = await fetch(`${root}cart/change.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: key, quantity, sections: 'cart-icon-bubble', sections_url: window.location.pathname }),
        });
        if (!response.ok) throw new Error(`cart/change: ${response.status}`);
        const cart = await response.json();
        applyCart(cart);
        updateCartIcon(cart);
        const item = cart.items.find((candidate) => candidate.key === key);
        if (item && item.quantity < quantity) showError(panel, 'Det er ikke flere på lager av denne varen.');
      } catch (error) {
        console.error(error);
        showError(panel, 'Kunne ikke endre antallet. Prøv igjen.');
      } finally {
        changing = false;
        panel.classList.remove('is-busy');
        panel.removeAttribute('aria-busy');
      }
    };

    panel = setupPreview(refresh);
    if (panel) {
      panel.addEventListener('click', (event) => {
        const button = event.target.closest('.cs-qty__button');
        if (!button || changing) return;
        const row = button.closest('.cs-preview__item');
        changeQuantity(row.dataset.key, Number(row.dataset.quantity) + Number(button.dataset.step));
      });
    }
    refresh();

    // Temaet tegner kurvikonet på nytt hver gang kurven endres, uansett hvor varen ble lagt til.
    const icon = document.getElementById('cart-icon-bubble');
    if (icon) {
      let timer;
      new MutationObserver(() => {
        clearTimeout(timer);
        timer = setTimeout(refresh, 100);
      }).observe(icon, { childList: true, subtree: true });
    }
    window.addEventListener('pageshow', (event) => {
      if (event.persisted) refresh();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
